import {Class} from 'type-fest';
import {isFunction} from './isFunction';

export function isInstanceOf<T>(cls?: Class<T>): (o?: unknown) => o is T {
    return isFunction(cls)
        ? (o?: unknown): o is T => o instanceof cls
        : (o?: unknown): o is T => false;
}
